
function SdFilterDatesController() {
    var ctrl = this;

    ctrl.selectOption = function (option) {
        console.log('selectOption ' + option);
        ctrl.value = option;
        if (option) {
            ctrl.onSelectOption({
                option: option
            });
            //if (this.onSelectOption) {
            //    this.onSelectOption(option);
            //}
        }
    };
}

seedWebApp.component('sdFilterDates', {
    controller: SdFilterDatesController,
    bindings: {
        parent: '<',
        label: '<',
        value: '<',
        options: '<',
        onSelectOption: '&'
    },
    templateUrl: '/SPA/components/filters/sd-filter-dates.html'
});